module.exports = __webpack_public_path__ + "static/media/managing-emotions.5eca2bd9.svg";